import { useEffect, useState } from 'react';
import { seriesAPI, teamsAPI, groundsAPI, fixturesAPI, cricclubsAPI } from '../../services/api';
import { PageHeader, SectionTitle } from '../../components/ui';
import useAuthStore from '../../store/authStore';

export default function DashboardPage() {
  const { user } = useAuthStore();
  const [data, setData] = useState({ series:[], teams:[], grounds:[], stats:{}, syncStatus:null });
  useEffect(() => {
    Promise.all([
      seriesAPI.list(), teamsAPI.list({}), groundsAPI.list(),
      fixturesAPI.stats(), cricclubsAPI.status()
    ]).then(([s,t,g,st,sy]) => setData({ series:s.data, teams:t.data, grounds:g.data, stats:st.data, syncStatus:sy.data })).catch(()=>{});
  }, []);
  return (
    <div>
      <PageHeader icon="⬡" title="Mich-CA Schedule Portal" subtitle="2026 Season · Dashboard"
        actions={<button className="btn btn-primary" onClick={()=>window.location.href='/series'}>+ New Series</button>}/>
      <div className="grid-4" style={{marginBottom:20}}>
        {[
          {label:'Active Series',value:data.series.filter(s=>s.status==='active').length||data.series.length,sub:'T20·F40·T30',color:'var(--accent)'},
          {label:'Total Teams',value:data.teams.length,sub:'Across all divisions',color:'var(--blue)'},
          {label:'Grounds',value:data.grounds.length,sub:'Cricket venues',color:'var(--gold)'},
          {label:'Total Fixtures',value:data.stats.total||0,sub:`${data.stats.confirmed||0} confirmed`,color:'var(--purple)'},
        ].map(s=>(
          <div key={s.label} className="card stat-card">
            <div className="stat-value" style={{color:s.color}}>{s.value}</div>
            <div className="stat-label">{s.label}</div>
            <div className="stat-sub">{s.sub}</div>
          </div>
        ))}
      </div>
      <div style={{display:'grid',gridTemplateColumns:'1.6fr 1fr',gap:16}}>
        <div className="card" style={{padding:16}}>
          <SectionTitle>Active Series</SectionTitle>
          {data.series.length===0 ? <p style={{color:'var(--mid)',fontSize:13}}>No series yet. Create your first series.</p> :
            data.series.slice(0,6).map(s=>(
              <div key={s.id} style={{display:'flex',justifyContent:'space-between',padding:'8px 0',borderBottom:'1px solid rgba(30,45,74,.4)',fontSize:13}}>
                <span>{s.name}</span>
                <span className={`tag ${s.status==='active'?'tag-green':'tag-gold'}`}>{s.status}</span>
              </div>
            ))
          }
        </div>
        <div className="card" style={{padding:16}}>
          <SectionTitle color="var(--gold)">CricClubs Sync</SectionTitle>
          {data.syncStatus?.last_sync ? (
            <div>
              <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:12}}>
                <div style={{width:8,height:8,borderRadius:'50%',background:'var(--accent)'}}/>
                <span style={{fontSize:12,color:'var(--mid)'}}>Last: {new Date(data.syncStatus.last_sync.timestamp).toLocaleString()}</span>
              </div>
              <span className={`tag ${data.syncStatus.last_sync.status==='success'?'tag-green':'tag-gold'}`}>{data.syncStatus.last_sync.status}</span>
              <span style={{fontSize:12,color:'var(--mid)',marginLeft:8}}>{data.syncStatus.last_sync.records_synced} records</span>
            </div>
          ) : <p style={{fontSize:12,color:'var(--mid)'}}>No sync performed yet.</p>}
          <button className="btn btn-ghost" style={{width:'100%',marginTop:12,fontSize:12}} onClick={()=>window.location.href='/cricclubs'}>⟳ Go to CricClubs Sync</button>
        </div>
      </div>
    </div>
  );
}
